import { render, staticRenderFns } from "./VariantDetails.vue?vue&type=template&id=17a3b5e0&scoped=true&lang=pug"
import script from "./VariantDetails.vue?vue&type=script&lang=js"
export * from "./VariantDetails.vue?vue&type=script&lang=js"
import style0 from "./VariantDetails.vue?vue&type=style&index=0&id=17a3b5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a3b5e0",
  null
  
)

export default component.exports